import classes from "~/features/selectionAssistant/gearbox/components/ResultsSection/components/ResultList/ResultList.module.less";
import { type SrpProductData } from "~/utils/models";
import { ResultTile } from "~/features/selectionAssistant/gearbox/components/ResultsSection/components/ResultTile/ResultTile";
import classNames from "classnames";

interface Props {
  className?: string;
  results: SrpProductData[];
}

export const ResultList = ({ className, results }: Props) => {
  return (
    <div className={classNames(className, classes.root)}>
      {results.map((result) => (
        <ResultTile key={result.code} product={result} />
      ))}
    </div>
  );
};
